export enum UNAVAILABLE_RESOURCE_TYPE {
    PROFILE = "PROFILE",
    ARTICLE = "ARTICLE",
    COLLECTION = "COLLECTION",
}